import { c as _c } from "react/compiler-runtime";
import { Dialog } from '@onefootprint/ui';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import ChoiceList, { type Choice } from '../choice-list';
import type { ReportSectionKind } from './report-outline';
import { KIND_GROUPS, KINDS_IN_GROUP, SECTION_KINDS } from './section-kinds';
type AddSectionDialogProps = {
  open: boolean;
  onClose: () => void;
  onPick: (kind: ReportSectionKind) => void;
};
const AddSectionDialog = t0 => {
  const $0 = _c(12);
  const {
    open,
    onClose,
    onPick
  } = t0;
  let t1;
  if ($0[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "agentBuilder.canvas.report"
    };
    $0[0] = t1;
  } else {
    t1 = $0[0];
  }
  const {
    t
  } = useTranslation("agents", t1);
  const picked = useRef(null);
  const choicesIn = group => KINDS_IN_GROUP(group).map(kind => {
    const KindIcon = SECTION_KINDS[kind].icon;
    return {
      id: kind,
      name: t($ => $.kinds[kind].label),
      description: t($_0 => $_0.kinds[kind].purpose),
      marker: <KindIcon />,
      onSelect: () => {
        picked.current = kind;
        onClose();
      }
    };
  });
  const T0 = Dialog;
  const t2 = true;
  const t3 = event => {
    const kind_0 = picked.current;
    if (!kind_0) {
      return;
    }
    picked.current = null;
    event.preventDefault();
    onPick(kind_0);
  };
  const t4 = "default";
  let t5;
  if ($0[1] !== t) {
    t5 = t(_temp);
    $0[1] = t;
    $0[2] = t5;
  } else {
    t5 = $0[2];
  }
  const t6 = "max-h-[min(48rem,calc(100vh-11rem))] overflow-y-auto px-6 py-6";
  const t7 = "flex flex-col gap-6";
  const t8 = KIND_GROUPS.map(group_0 => <section className="flex flex-col gap-2.5" key={group_0}><h3 className="text-label-3 text-tertiary">{t($_2 => $_2.groups[group_0])}</h3><ChoiceList choices={choicesIn(group_0)} /></section>);
  let t9;
  if ($0[3] !== t8) {
    t9 = <div className={t6}><div className={t7}>{t8}</div></div>;
    $0[3] = t8;
    $0[4] = t9;
  } else {
    t9 = $0[4];
  }
  let t10;
  if ($0[5] !== T0 || $0[6] !== onClose || $0[7] !== open || $0[8] !== t3 || $0[9] !== t5 || $0[10] !== t9) {
    t10 = <T0 noPadding={t2} onClose={onClose} onCloseAutoFocus={t3} open={open} size={t4} title={t5}>{t9}</T0>;
    $0[5] = T0;
    $0[6] = onClose;
    $0[7] = open;
    $0[8] = t3;
    $0[9] = t5;
    $0[10] = t9;
    $0[11] = t10;
  } else {
    t10 = $0[11];
  }
  return t10;
};
export default AddSectionDialog;
function _temp($_1) {
  return $_1.addSection;
}